<template>
  <div class="newton-first-law-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="200" viewBox="0 0 400 200">
        <!-- 冰面/路面 -->
        <rect x="0" y="150" width="400" height="50" :fill="mu < 0.05 ? '#e1f5fe' : '#333'" />
        <line x1="0" y1="150" x2="400" y2="150" stroke="#fff" stroke-width="1" stroke-dasharray="10,5" v-if="mu < 0.05" />
        
        <!-- 滑块 -->
        <g :transform="`translate(${pos}, 130)`">
          <rect x="-20" y="0" width="40" height="20" fill="#00d2ff" rx="2" />
          <text y="-10" text-anchor="middle" fill="#aaa" font-size="10">m</text>
          
          <!-- 速度矢量 -->
          <line x1="0" y1="10" :x2="v * 10" y2="10" stroke="#2ed573" stroke-width="3" marker-end="url(#arr-v)" v-if="v > 0" />
        </g>

        <!-- 提示文本 -->
        <text x="200" y="80" text-anchor="middle" fill="#888" font-size="12" v-if="v === 0 && pos > 50">物体最终停止 (有外力作用)</text>
        <text x="200" y="80" text-anchor="middle" fill="#2ed573" font-size="12" v-else-if="mu === 0 && v > 0">匀速直线运动 (不受外力)</text>
      </svg>
    </div>

    <div class="controls">
      <div class="slider-row">
        <span>摩擦系数 μ:</span>
        <el-slider v-model="mu" :min="0" :max="0.5" :step="0.01" size="mini"></el-slider>
      </div>
      <div class="btn-row">
        <el-button type="primary" size="mini" @click="push">给予初速度</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
      <p class="desc">当 μ=0 时，物体不受摩擦力，将保持匀速直线运动。</p>
    </div>

    <defs>
      <marker id="arr-v" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
        <polygon points="0 0, 6 2, 0 4" fill="#2ed573" />
      </marker>
    </defs>
  </div>
</template>

<script>
export default {
  name: 'NewtonFirstLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mu: 0.1,
      v: 0,
      pos: 50,
      running: true
    }
  },
  mounted() {
    this.animate();
  },
  beforeDestroy() {
    this.running = false;
  },
  methods: {
    push() {
      this.v = 5;
      this.pos = 50;
    },
    reset() {
      this.v = 0;
      this.pos = 50;
    },
    animate() {
      if (!this.running) return;
      
      if (this.v > 0) {
        // 摩擦力加速度 a = μg (g取10)
        const a = this.mu * 10;
        this.v -= a * 0.016;
        if (this.v < 0) this.v = 0;
        
        this.pos += this.v;
        if (this.pos > 400) this.pos = 0;
      }
      
      requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.newton-first-law-viz {
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.viz-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  .title { color: #00d2ff; font-weight: bold; }
  .stats { font-size: 0.8rem; color: #888; }
}
.canvas-box { background: #0a0a0a; border-radius: 8px; overflow: hidden; }
.controls {
  padding: 15px;
  background: rgba(46, 213, 115, 0.05);
  border-radius: 8px;
  .slider-row { display: flex; align-items: center; gap: 15px; span { font-size: 0.85rem; } .el-slider { flex: 1; } }
  .btn-row { display: flex; gap: 10px; margin-top: 10px; }
  .desc { font-size: 0.8rem; color: #888; margin-top: 10px; text-align: center; }
}
</style>
